import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { AdminsApi } from 'api';

function useUpdateRoles() {
  const queryClient = useQueryClient();
  return useAuthMutation(
    ({ id, roleIds }: { id: number; roleIds: number[] }) =>
      AdminsApi.putRoles(id, roleIds),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: getQueryKeys([KEY]).all });
      },
    },
  );
}

export default useUpdateRoles;
